define([
	'internal_util/Util',
	'service/WorkerPool',
	'lib/qrcode'
], function (
	Util,
	WorkerPool,
	QRCode
) {
	'use strict';

	/**
	 * QRCodeService class
	 */
	return function () {
		var _context = document.createElement('canvas').getContext('2d'),
			_maxImageWidth = 800,
			_maxImageHeight = 640,
			_qrCodeWidth = 250,
			_qrCodeHeight = 250,
			_qrCodeCorrectLevel = QRCode.CorrectLevel.L;


		// private methods

		function getImageData(src) {
			var height,
				width;

			if (src.videoWidth && src.videoHeight) {
				width = src.videoWidth;
				height = src.videoHeight;
			} else if (src.width && src.height) {
				width = src.width;
				height = src.height;
			} else {
				return null;
			}

			if (width > height && width > _maxImageWidth) {
				height *= _maxImageWidth / width;
				width = _maxImageWidth;
			} else if (height > _maxImageHeight) {
				width *= _maxImageHeight / height;
				height = _maxImageHeight;
			}

			try {
				_context.canvas.width = width;
				_context.canvas.height = height;

				_context.drawImage(src, 0, 0, width, height);

				return _context.getImageData(0, 0, _context.canvas.width, _context.canvas.height);
			} catch (e) {
				return null;
			}
		}


		// public methods

		this.decode = function (src, callbacks) {
			var imageData;

			if (!WorkerPool.busy()) {
				imageData = getImageData(src);

				WorkerPool.run('qrcode_decode', imageData, callbacks);
			}
		};

		this.encode = function (element, text) {
			try {
				new QRCode(element[0], { //lib works with DOM
						text : text,
						width : _qrCodeWidth,
						height : _qrCodeHeight,
						correctLevel : _qrCodeCorrectLevel
					});
			} catch (e) {
                            console.error(e);
				// TODO: implement error handling
			}
		};

		this.cancelDecode = function () {
			WorkerPool.cancel('qrcode_decode');
		};
	}
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/service/QRCodeService.js
// module id = 159
// module chunks = 4